export default "__VITE_ASSET__5405b18c__"